export default "__VITE_ASSET__fh8A8xhmk_8WwfieG$mE8A__";